<!--
--
-- Navigation View History -> Display Toolbar for Individual Document.
-- We expect that the actualDocument is defined
--
-->
<template>
    <div id="sticky">
        <v-toolbar class="my-toolbar">

            <v-btn  icon v-on:click="$emit('back')">
                <v-icon>navigate_before</v-icon>
            </v-btn>

            <v-btn icon :disabled="endOfPage || isButtonsDisabled()" v-on:click="$emit('next')">
                <v-icon>navigate_next</v-icon>
            </v-btn>

            <v-spacer/>

            <v-tooltip open-on-hover  bottom>
                <span>{{$t('attributes.save')}}</span>
                <template #activator="data">
                    <v-btn icon v-on="data.on" :loading="processing.processingSave"
                           @click="doExport()"
                           :disabled="isButtonsDisabled() || processing.processingSave">
                        <v-icon>save</v-icon>
                    </v-btn>
                </template>
            </v-tooltip>


        </v-toolbar>
        <v-alert :value="error!=null" type="error">{{error}}</v-alert>
        <v-progress-linear v-if="progress != 100" :value="progress"/>
    </div>
</template>


<script>
    import EnvService from '@/services/EnvService'

    export default {
        name: "my-document-toolbar",

        props: ['endOfPage'],

        data: () => ({
            toolbarElement: null,
            top: 0,
            link: null,
            processing: {
                processingSave: false,
                processingPrint: false,
            }
        }),

        methods: {
            setView(view) {
                console.log('setView:' + view)
                this.view = view;
                this.$emit('update:view', view)
            },

            isButtonsDisabled() {
                return EnvService.isURLNotSupported() || this.progress < 100.0
            },

            doExport() {
                // clear existing errors
                this.$store.dispatch('setError', null)

                // create link and simulate click on it
                var url = this.$store.state.downloadStore[this.documentId].url
                if (this.link == null) {
                    this.link = document.createElement('a');
                    this.link.setAttribute("id", "downloadContent");
                }
                this.link.setAttribute('Download', this.documentId);
                this.link.href = url;
                document.body.appendChild(this.link);
                this.link.click();
            },

        },

        computed: {
            documentId() {
                return this.$route.params.downloadId;
            },

            documentInStore() {
                return this.$store.state.downloadStore[this.documentId]
            },

            progress() {
                return this.documentInStore.percent
            },

            pageCount() {
                return this.$store.state.actualDocumentNumberOfPages
            },

            isProcessing() {
                return this.$store.state.isProcessing
            },

            error() {
                return this.$store.state.error
            }

        }
    }

</script>

<style scoped>
    #sticky {
        top: 63px;
        height: 63px;
        z-index: 1;
        position: -webkit-sticky;
        position: sticky;
        visibility: visible;
    }

    .myToolbar > > .v-toolbar__content {
        height: 63px;
    }


</style>